import { cn } from "../lib/utils";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={cn("w-full py-5 px-4 md:px-6 mt-5", "bg-background border-t")}
    >
      <div className="flex flex-col md:flex-row justify-between items-center">
        <p className="text-sm text-slate-500 dark:text-slate-400">
          &copy; {currentYear} Ali Academy. All rights reserved.
        </p>
        <div className="mt-4 md:mt-0">
          <ul className="flex flex-wrap gap-4 text-sm text-slate-500 dark:text-slate-400">
            <li>
              <Link
                href="#"
                className="hover:text-blue-600 dark:hover:text-blue-400"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                href="#"
                className="hover:text-blue-600 dark:hover:text-blue-400"
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link
                href="#"
                className="hover:text-blue-600 dark:hover:text-blue-400"
              >
                Licensing
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
